import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { HeadingRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: HeadingRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function HeadingRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "heading",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("HeadingRegionTypeCard.title")}
      description={t("HeadingRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
